import { render } from "./withAdminLayout.vue?vue&type=template&id=72f2ac0c"
import script from "./withAdminLayout.vue?vue&type=script&lang=js"
export * from "./withAdminLayout.vue?vue&type=script&lang=js"

import "./withAdminLayout.vue?vue&type=style&index=0&id=72f2ac0c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__